export default __webpack_public_path__ + "static/media/jee_legacy_mobile.aedd90df.svg";